import React, { useContext } from 'react';
import { useLang } from '../../../_LangContext'
import { UIIconSelect } from '../basic';

const UISelectSiteOrder = ({ onChange, value }) =>
{
	const { getText } = useLang();

	const options = [
		{
			value: 'default',
			label: getText('default'),
		},
		{
			value: 'year',
			label: getText('by-year'),
		}
	];

	return (
		<UIIconSelect
			className="sort site-order"
			iconClass="icon up-down"
			options={options}
			value={value}
			onChange={onChange}
		/>
	);
};

export default UISelectSiteOrder;
